import React, { useState } from 'react';
import { Dialog as HeadDialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import Button from './Button';
import { Cross } from '../ui/Icons';

export default function Dialog({
  buttonClasses,
  buttonContent,
  dialogTitle = undefined,
  dialogContent,
}: {
  buttonClasses: string,
  buttonContent: JSX.Element,
  dialogTitle: string | undefined,
  dialogContent: JSX.Element,
}) {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const handleDialogToggle = (show: boolean) => setShowDialog(show);

  return (
    <>
      <Button
        classes={buttonClasses}
        handleDialogToggle={handleDialogToggle}
      >
        {buttonContent}
      </Button>
      <HeadDialog open={showDialog} onClose={() => setShowDialog(false)} className="relative z-[9999]">
        <DialogBackdrop className="fixed inset-0 bg-near-black/50" />
        <div className="fixed inset-0 items-center h-svh overflow-y-auto">
          <DialogPanel className="bg-white rounded-lg shadow-md-secondary w-full md:pt-8 md:pb-12 p-4 md:px-12 text-sm md:text-base mx-auto my-4 md:my-8 max-w-modal-sm">
            <div className="relative flex gap-4 pb-4 md:pb-7.5 mb-4 md:mb-7.5 border-b border-light-grey-1.5">
              {dialogTitle && (
                <h3 className="text-xl md:text-2xl-secondary leading-tight flex-1.0">
                  {dialogTitle}
                </h3>
              )}
              <button
                className="btn-close absolute top-0 right-0 bottom-0 w-8 md:w-12 h-8 md:h-12 p-2 md:p-3 flex items-center justify-center transition-colors text-near-black  hover:text-accent"
                type="button"
                onClick={() => setShowDialog(false)}
              >
                <span className="sr-only">Close modal</span>
                <Cross className="w-full h-full" />
              </button>
            </div>
            {dialogContent}
          </DialogPanel>
        </div>
      </HeadDialog>
    </>
  );
}
